import { uniformGridSpec } from '@/utils/gridSpec';

import { LayoutTemplate, TemplateGroup } from '../layoutTemplates.types.ts';
import { PageNames } from '../pageNames.ts';

/** Templates suited to standard (16:9 / 16:10) screens. */
export const standardTemplates: LayoutTemplate[] = [
  {
    id: 'grid-2x2',
    name: 'grid-2x2',
    group: TemplateGroup.Standard,
    pageName: PageNames.Dashboard,
    spec: uniformGridSpec(2, 2),
  },
  {
    id: 'grid-3x2',
    name: 'grid-3x2',
    group: TemplateGroup.Standard,
    pageName: PageNames.Dashboard,
    spec: uniformGridSpec(3, 2),
  },
  {
    id: 'grid-3x3',
    name: 'grid-3x3',
    group: TemplateGroup.Standard,
    pageName: PageNames.Dashboard,
    spec: uniformGridSpec(3, 3),
  },
  {
    id: 'grid-4x2',
    name: 'grid-4x2',
    group: TemplateGroup.Standard,
    pageName: PageNames.Dashboard,
    spec: uniformGridSpec(4, 2),
  },
  {
    id: 'grid-4x3',
    name: 'grid-4x3',
    group: TemplateGroup.Standard,
    pageName: PageNames.Dashboard,
    spec: uniformGridSpec(4, 3),
  },
  {
    id: 'grid-5x2',
    name: 'grid-5x2',
    group: TemplateGroup.Standard,
    pageName: PageNames.Dashboard,
    spec: uniformGridSpec(5, 2),
  },
];
